module.exports = require("@swa-ui/core/src/Timer/Timer.module.scss");